import React from 'react';
import PropTypes from 'prop-types';
import OrderPaymentDisplayType from '../../OrderPaymentDisplayType';

function OrderPaymentDisplayFactory({ orderPaymentStatusType }) {
  switch (orderPaymentStatusType) {
    case OrderPaymentDisplayType.PAID:
      return (
        <div>
          Paid
        </div>
      );
    case OrderPaymentDisplayType.OPEN:
      return (
        <div className="text-danger">
          Open
        </div>
      );
    case OrderPaymentDisplayType.CANCELLED:
      return <div>Cancelled</div>;
    case OrderPaymentDisplayType.CLOSED:
      return <div>Closed</div>;
    case OrderPaymentDisplayType.REFUNDED:
      return <div>Refunded</div>;
    default:
      return (<div> - </div>);
  }
}

OrderPaymentDisplayFactory.propTypes = {
  orderPaymentStatusType: PropTypes.number.isRequired,
  // dueDate: PropTypes.oneOfType([
  //   PropTypes.number,
  //   PropTypes.any,
  // ]),
};

// OrderPaymentDisplayFactory.defaultProps = {
//   dueDate: null,
// };

export default OrderPaymentDisplayFactory;
